import * as React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./Permission.css";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../Redux/store";

// Define prop types
interface PermissionProps {
  message?: number; // optional numeric code
  email?: string;   // optional email to display in messages
}

const Permission: React.FC<PermissionProps> = ({ message, email }) => {
  const { logout } = useAuth0();
  const { uiDictionary, labelloading, isLoaded } = useSelector((state: RootState) => state.labels);


  // const renderMessage = () => {
  //   switch (message) {
  //     case 999:
  //       return (
  //         <p style={{ textAlign: "left", fontSize: "16px", color: "#555" }}>
  //           The outlook account <br/><b>{email}</b> is not connected to Clarra.
  //           <br />
  //           <p>Return to Clarra and connect your outlook email to continue.</p>
  //         </p>
  //       );
  //     case 888:
  //       return (
  //         <p style={{ textAlign: "left", fontSize: "16px", color: "#555" }}>
  //           The outlook account currently connected to Clarra does not match <br/><b>{email}</b>.

  //           <br />
  //           <p>Return to Clarra and reconnect your outlook email to continue.</p>
  //         </p>
  //       );
  //     case 777:
  //       return (
  //         <p style={{ textAlign: "left", fontSize: "16px", color: "#555" }}>
  //           Access of the outlook account <br/><b>{email}</b> in Clarra has expired.
  //           <br />
  //          <p>Return to Clarra and connect your outlook email to continue.</p>
  //         </p>
  //       );
  //     default:
  //       // Default permission message
  //       return (
  //         <>
  //           <h2 style={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
  //             You do not have permission to log
  //           </h2>
  //           <h1 style={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
  //             Communication, Timeslip and ClarraDocs.
  //           </h1>
  //         </>
  //       );
  //   }
  // };
const renderMessage = (): JSX.Element => {
  const commonStyle: React.CSSProperties = {
    textAlign: "left",
    fontSize: 14, // number -> treated as px by React
    color: "#555",
    marginTop:"-50px"
  };

  switch (message) {
    case 999:
      return (
        <div style={commonStyle} >
          <p>
            Your Outlook account <br />
            <b>{email}</b> is not connected to Clarra.
          </p>
          <p>Please return to Clarra and connect your Outlook email to continue.</p>
        </div>
      );

    case 888:
      return (
        <div style={commonStyle}>
          <p>
            Your Outlook account currently connected to Clarra does not match <br />
            <b>{email}</b>.
          </p>
          <p>Please return to Clarra and reconnect your Outlook email to continue.</p>
        </div>
      );

    case 777:
      return (
        <div style={commonStyle}>
          <p>
            The existing connection of your Outlook account<br />
            <b>{email}</b> to Clarra has been expired.
          </p>
          <p>Please return to Clarra and reconnect your Outlook email to continue.</p>
        </div>
      );

    default:
      return (
        <div style={{ textAlign: "center", color: "#333" }}>
          <h2 style={{ fontSize: 16 }}>You do not have permission to log</h2>
          <h1 style={{ fontSize: 16 }}>{uiDictionary.Communication}, {uiDictionary.Timekeeping}, and {uiDictionary.ClarraDocs}.</h1>
        </div>
      );
  }
};

  return (
    <div className="login-container">
      <div className="login-box">
        <div style={{ maxWidth: "600px", margin: "0 auto", padding: "20px" }}>
          {renderMessage()}
        </div>

        {/* Optional logout button */}
        {/* <button onClick={handleLogout} className="login-button">Sign out</button> */}
      </div>
    </div>
  );
};

export default Permission;
